import { useState, useEffect, useMemo } from "react";
import { fetchSmartLinks } from "../services/smartLinkFetchService";

export const useSmartLinksList = () => {
  const token = localStorage.getItem("access_token");
  const apiUrl = process.env.REACT_APP_API_URL_PROD + '/api/v1/smartlinks_list';
  const itemsPerPage = 20;

  const [dataLinks, setDataLinks] = useState([]);
  const [loadingLinks, setLoadingLinks] = useState(true);
  const [errorLinks, setErrorLinks] = useState(null);
  const [currentPageLinks, setCurrentPageLinks] = useState(1);
  const [filtrosLinks, setFiltrosLinks] = useState({
    status: "",
    linkId: "",
  });
  const [selectedColumnsLinks, setSelectedColumnsLinks] = useState([]);

  // --- FETCH DATOS ---
  useEffect(() => {
    const getData = async () => {
      setLoadingLinks(true);
      setErrorLinks(null);
      try {
        const formattedLinks = await fetchSmartLinks(apiUrl, token);
        setDataLinks(formattedLinks);
      } catch (err) {
        setErrorLinks(err.message);
      } finally {
        setLoadingLinks(false);
      }
    };

    getData();
  }, [token, apiUrl]);

  // --- FILTRADO Y PAGINACIÓN ---
  const { currentItemsLinks, totalPagesLinks } = useMemo(() => {
    const filtered = dataLinks
      .filter((item) =>
        filtrosLinks.status ? item.status === filtrosLinks.status : true
      )
      .filter((item) =>
        filtrosLinks.linkId
          ? String(item.id).toLowerCase().includes(filtrosLinks.linkId.toLowerCase())
          : true
      );

    const totalPagesCalc = Math.ceil(filtered.length / itemsPerPage);
    const startIndex = (currentPageLinks - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const current = filtered.slice(startIndex, endIndex);

    return {
      currentItemsLinks: current,
      totalPagesLinks: totalPagesCalc || 1,
    };
  }, [dataLinks, filtrosLinks, currentPageLinks]);

  // --- HANDLERS ---
  const handleInputChangeLinks = (e, key) => {
    setFiltrosLinks({ ...filtrosLinks, [key]: e.target.value });
    setCurrentPageLinks(1);
  };

  const handleSelectChangeLinks = (value, key) => {
    setFiltrosLinks({ ...filtrosLinks, [key]: value });
    setCurrentPageLinks(1);
  };

  const handlePageChangeLinks = (newPage) => setCurrentPageLinks(newPage);

  return {
    currentItemsLinks,
    totalPagesLinks,
    loadingLinks,
    errorLinks,
    filtrosLinks,
    currentPageLinks,
    selectedColumnsLinks,
    setSelectedColumnsLinks,
    handleInputChangeLinks,
    handleSelectChangeLinks,
    handlePageChangeLinks
  };
};